
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 35.2c7.7 0 15.5-.1 23.1.1v13.4h-4.3v43.9c-4.8 0-9.8.1-14.5-.1V48.6H0V35.2zM26.4 35.3h14.4v57.3H26.3V35.5c.1-.1 0-.2.1-.2zM67 36.9v11.9c-.3.1-.5-.4-.8-.6-2.2-1.6-5.5 0-5.8 2.6-.1 1.2.3 2.6.5 3.9.8 3.7 1.8 7.2 2.8 10.5 1.4 4.4 3.4 9.1 3 14.7-.4 5.3-2.8 9.1-6.6 11.2-1.9 1.1-4.4 1.7-7.2 1.5-2.7-.2-4.8-.8-7.1-1.8V77.7c.2-.1.6.2.9.4.3.2.6.4 1 .5 2.3.8 5.1-.3 5.3-2.7.2-2.1-.5-4.5-1.1-6.4-1.8-5.7-4.3-10.6-5.4-17.2-.8-4.9-.1-9 2.3-12.1 1.1-1.4 2.5-2.6 4.1-3.4 1.6-.9 3.4-1.6 5.7-1.8 3.5 0 5.9 1.1 8.4 1.9zM90.2 35.3v12.3c-3.7-.4-6.1.5-6.9 3.1-.5 1.6-.2 4.3-.2 6.4v13.2c0 2.2-.3 4.7.2 6.4.7 2.8 3.3 3.8 7 3.4v12.3c-7.9.4-13-2.4-16.2-6.9-1.7-2.3-2.8-5-3.2-8.3-.2-1.7-.1-3.7-.1-5.7V54.2c0-2 0-3.8.3-5.5.9-4.5 3.6-8.2 6.8-10.5 3-2 6.9-3.3 12.3-2.9zM110.3 35.3c7.2-.5 12.1 3.4 14.9 7.7 1.6 2.5 2.6 5.2 2.7 8.6.2 4.1 0 7.5 0 11.3v11.3c0 3.7-.6 6.9-2 9.3-2.6 4.8-7.2 8.4-13.7 8.9-3.6.3-6.7-.8-9.1-2.1-2.3-1.3-4.4-3.2-5.8-5.5-1.5-2.3-2.6-5.2-2.7-8.6-.2-7.5 0-15.2 0-22.6 0-4.1.6-6.6 2-9.3 1.9-3.6 4.8-6.5 9-8 1.4-.5 3-.8 4.7-1zm-3 15.1c-.7 1.7-.4 4.5-.4 6.4v13.7c0 2.4-.3 5 .2 6.6.8 2.4 3.4 3.9 5.8 2.8.9-.4 2-1.5 2.4-2.8.5-1.6.2-4.5.2-6.4V57.4c0-2.3.3-4.9-.2-6.5-.6-1.9-2.3-3.5-4.7-3.1-1.7.1-2.7 1.3-3.3 2.6z"}})])])
          )
        }
      }
    